import { combineReducers } from 'redux';

import {ACTION} from './constants';

let initialState={
     financialInformation:{},
};

function AboutReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION.GET_ABOUT_US_CONTENT :
            return {...state, aboutContent:action.data, pageMeta: action.data};
        case ACTION.GET_ANNUAL_REPORT :
            return {...state, financialInformation:{...state.financialInformation, annualReport:action.data}, pageMeta: action.data};          
        case ACTION.GET_CODE_GOVERNANCE :
            return {...state, corporateGovernance:{...state.corporateGovernance, codePolicy:action.data}, pageMeta: action.data};
        case ACTION.GET_BOARD_COMMITTEE :
            return {...state, corporateGovernance:{...state.corporateGovernance, boardCommittee:action.data}};
        case ACTION.GET_DISCLOSURES :
            return {...state, corporateGovernance:{...state.corporateGovernance, disclosures:action.data}};
        case ACTION.GET_DIVIDEND :
            return {...state, corporateGovernance:{...state.corporateGovernance, dividend:action.data}};
        case ACTION.GET_FINANCIAL_RESULT :
            return {...state, financialInformation:{...state.financialInformation, financialResult:action.data}};
        case ACTION.GET_SHAREHOLDER_PRESENTATION :
            return {...state, financialInformation:{...state.financialInformation, shareholderPpt:action.data}};
        case ACTION.GET_LEADERSHIP_PROFILE :
            return {...state, leaderShipMsg:{...state.leaderShipMsg, leadership:action.data}, pageMeta: action.data};
        case ACTION.GET_HDFC_MF_GLANCE_CONTENT :
            return {...state, aboutUsMsg:{...state.aboutUsMsg, aboutUs:action.data}, pageMeta: action.data};
        case ACTION.GET_ABOUT_US_MEDIA_CENTER :
            return {...state, mediaCenterMsg:{...state.mediaCenterMsg, mediaCenter:action.data}, pageMeta: action.data};
        case ACTION.GET_ABOUT_US_MEDIA_CENTER_VIDEO :
            return {...state, mediaCenterVideo:{...state.mediaCenterVideo, mediaCenter:action.data}, pageMeta: action.data};
        case ACTION.GET_CSR :
            return {...state, csrData:{...state.csrData, csr:action.data}, pageMeta: action.data};
        default:
            return state;
    }
}


export default combineReducers({
    home: AboutReducer,
});